export const buildQuickPricerPayload = (payload) => {
  return {
    qmInformation: {
      refinancePrepaymentFeeAmount: 0,
      creditInsuranceFeeAmount: 0,
      cashIncentiveDiscountAmount: 0,
      escrowTrusteeFeeAmount: 0,
      propertyAssessmentFeeAmount: 0,
      notaryCreditReportFeeAmount: 0,
      documentPreperationFeeAmount: 0,
      titleFeeAmount: 0,
      borrowerPaidLOCompensation: 0,
      additionalQMFeesAffectAPOR: false,
      additionalQMFeeAmount: 0,
      financedPMI: 0
    },

    borrowerInformation: {
      citizenship: payload.citizenship,
      fico: Number(payload.qualifyingCreditScore),
      firstName: "test", // replace if coming from form
      lastName: "test1", // replace if coming from form
      vaFirstTimeUse: false,
      firstTimeHomeBuyer: payload.firstTimeHomeBuyer === "Yes",
      monthsReserves: Number(payload.reserve),
      selfEmployed: payload.selfEmployed === "Yes",
      waiveEscrows: payload.escrowWaiver === "Yes",
      state: payload.state
    },

    propertyInformation: {
      appraisedValue: Number(payload.estimatedValue),
      occupancy: payload.occupancy,
      propertyStreetAddress: "Test Address", // replace if in form
      city: payload.city,
      county: payload.county,
      state: payload.state,
      zipCode: payload.zipcode,
      propertyType: payload.propertyType,
      corporateRelocation: false,
      salesPrice: Number(payload.purchasePrice),
      numberOfStories: Number(payload.numberofStories),
      numberOfUnits: payload.numberofUnits
    },

    loanInformation: {
      loanPurpose: payload.loanPurpose,
      lienType: payload.lienType,
      amortizationTypes: payload.amortizationTypes || [],
      armFixedTerms: payload.ARMFixedTerms || [],
      automatedUnderwritingSystem: "NotSpecified",
      borrowerPaidMI: payload.lenderPaidvsBorrowerPaid === "YesLenderPaid" ? "Yes" : "No",
      buydown: "None",
      cashOutAmount: Number(payload.cashoutAmount),
      desiredLockPeriod: Number(payload.desiredLockPeriod),
      desiredPrice: Number(payload.desiredPrice),
      desiredRate: Number(payload.desiredRate),
      feesIn: "No",
      expandedApprovalLevel: "NotApplicable",
      interestOnly: payload.interestOnly === "Yes",
      baseLoanAmount: Number(payload.loanAmount),
      secondLienAmount: Number(payload.closedEndSecondLienAmt),
      helocDrawnAmount: Number(payload.helocDrawnAmount),
      helocLineAmount: Number(payload.helocLineAmount),
      productTypes: payload.productType || [],
      loanTerms: payload.loanTerms || [],
      loanType: payload.loanType?.[0] || "",
      prepaymentPenalty: payload.prePaymentPenalty || "None",
      exemptFromVAFundingFee: false,
      includeLOCompensationInPricing: payload.lenderPaidvsBorrowerPaid,
      calculateTotalLoanAmount: true,
      assetDepletion: "No",
      autoDebit: "No",
      employeeLoan: "No",
      communityAffordableSecond: "No",

      expandedGuidelines: {
        incomeVerificationType: payload.incomeVerificationType,
        housingEventType: payload.housingEventType,
        housingEventSeasoning: payload.housingEventSeasoning,
        bankruptcyType: payload.bankruptcyType,
        bankruptcyOutcome: payload.bankruptcyOutcome,
        bankruptcySeasoning: payload.bankruptcySeasoning,
        mortgageLatesx30_12Mos: Number(payload.Mtg_Lates_x30_12),
        mortgageLatesx30_13to24Mos: Number(payload.Mtg_Lates_x30_13_24),
        mortgageLatesx60_12Mos: Number(payload.Mtg_Lates_x60_12),
        mortgageLatesx60_13to24Mos: Number(payload.Mtg_Lates_x60_13_24),
        mortgageLatesx90_12Mos: Number(payload.Mtg_Lates_x90_12),
        mortgageLatesx90_13to24Mos: Number(payload.Mtg_Lates_x90_13_24),
        mortgageLatesx120_12Mos: Number(payload.Mtg_Lates_x120_12),
        mortgageLatesx120_13to24Mos: Number(payload.Mtg_Lates_x120_13_24),
        debtConsolidation: false,
        uniqueProperty: false,
        debtServiceCoverageRatio: payload.debtServiceCoverageRatio
          ? Number(payload.debtServiceCoverageRatio)
          : null
      },
      "customFields": [{
        customFieldInputName: "CustomProductFilter03",
        customFieldValue: (payload.shortTermRental === "Yes" ? "109" : "110"),
        columnName: "CustomLenderField7",
     }],

      reducedMI: false,
      representativeFICO: Number(payload.qualifyingCreditScore),
      loanLevelDebtToIncomeRatio: Number(payload.debtToIncomeRatio),
      totalMonthlyQualifyingIncome: 0, // replace if available
      customerInternalId: "OBSearch"
    }
  }
};